// CVs provide optional context and never require document approval. Check the
// category/key as well as the new status so older CV uploads behave the same.
export function requiresDocumentReview(file) {
  const key = String(file?.review?.requirementKey || file?.requirementKey || '').trim();
  return file?.intakeCategory !== 'cv'
    && !/^(?:party[:|].+[:|]cv|additional[:|]cv)$/.test(key)
    && file?.review?.status !== 'not_required';
}

export function hasPendingDocumentReview(submission) {
  return (submission?.files || []).some(file => file.objectPath && requiresDocumentReview(file)
    && !['approved', 'rejected', 'staff_upload_pending'].includes(file.review?.status));
}
